if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


let form_id_88 = document.querySelector( "#form_id-88" )

function removeRequiresFiles(){
	let files = form_id_88.querySelectorAll( "[type=file]" )
	files.forEach( ( item, index ) => {
		item.parentNode.querySelector( "[type=text]" ).classList.remove( "required" )
		item.classList.remove( "required" );
	} );
}

(function(){

	
	if( form_id_88 ){

		removeRequiresFiles();

		let radios = form_id_88.querySelectorAll( "[name*=level_applied_for]" );
		radios.forEach( ( item, index ) => {
			item.addEventListener( "change", ( e ) => {
				let value = e.target.value
				
				removeRequiresFiles();

				switch( value ){
					case "silver":
						let silverfield = document.querySelector( ".field_88_14 input" )
						silver.classList.add( "required" );
						break
					case "gold":
						let goldfield = document.querySelector( ".field_88_17 input" )
						goldfield.classList.add( "required" );
						let goldfield1 = document.querySelector( ".field_88_19 input" )
						goldfield1.classList.add( "required" );
						let goldfield2 = document.querySelector( ".field_88_21 input" )
						goldfield2.classList.add( "required" );
						break
					case "les_clefs_dor_member_transfer":
						let lesfield = document.querySelector( ".field_88_23 input" )
						lesfield.classList.add( "required" );
						break	
				}

			} )
		} )

	}

	if( localStorage.getItem( "member" )){
		$('#login').addClass('hidden');
		$('#logout').removeClass('hidden');
		$('#burger').removeClass('hidden');
	}else{
		$('#login').removeClass('hidden');
		$('#logout').addClass('hidden');
		$('#burger').addClass('hidden');
	}
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // ADD MODAL CLASS & ID TO TEXT-MODULE WRAPPER
    document.querySelectorAll('.js-form_modal').forEach((item, i) => {
        item.parentNode.classList.add('text-modules-modal');
        item.parentNode.id = `form_modal-${i+1}`;
    });

    // TRIGGER FANCYBOX FROM LOCATION HASH
    if (window.location.hash) {
        document.querySelectorAll(`[data-fancybox]`).forEach(link => {
            if (link.hash === window.location.hash) link.click();
        });
    }
	//Add Event Listener "Level Applied" Field
	if(location.pathname.indexOf('/membership-application')>-1){
		let levelApp = document.getElementsByName("level_applied_for[]"),
		formId = 88;
		for(let cBox of levelApp){
			cBox.addEventListener('change',(e,i)=>{
				if(cBox.checked==true)
					document.getElementById(`sendto_${formId}`).value= 'Houston.Munroe@marriott.com';	

			})
		}
	}
	

})();

function loginMembers(e){
    e.preventDefault();
	var extras = new Object(),formId = "loginForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'loginMembers',
		email: $("#email").val(),
		password: $("#password").val()
	},
	function(data){
		if(data.result == 'success') {
			localStorage.setItem( "member", data.name );

			extras.page_redirect = '/welcome';
			document.location = "/welcome";
			if(data.warning==1)
				localStorage.setItem('msg',1);
			//showResult(data, formId, extras);
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function activeAccount(e){
	e.preventDefault();
    var extras = new Object(),formId = 'activeForm',$processpage = 'ajax/functions.php';;
	extras.dont_hide_form = "1";
    extras.dont_reset_form = "1";

    $("#processing").show();
	$("#btnSubmit").hide();
	
	$('.errorMsg').slideUp();
    $(".errorMsg").html('');

    clearErrors(formId);
    formProcessSetup(formId);
    
    $.post(site_url+$processpage,
        { 
            operation: 'activeAccount', 
            email_reset: $("#email_reset").val(),
            token: $("#token").val(),
            password_reset: $('#password_reset').val(),
            confirm_password : $('#confirm_password').val()
        },function(data){
            if(data.result=='success'){
                //toastr.success('Thank you for your request.');
                $("#email_reset").val('');
                $('#password_reset').val('');
                $('#confirm_password').val('');
                $('#activeForm .errorMsg').slideDown();
				$(".errorMsg").html('Thank you. Your password has been reset. Please save this password for your records.');
				extras.page_redirect = "index.php";
				setTimeout(()=>{
					showResult(data,formId,extras);
				},4000);
            }else{
                showErrors(data,formId,extras);
            }
            $("#processing").hide();
        },
        "json"
    );
}

function processRecovery(e){
	e.preventDefault();
	var extras = new Object(),formId = "forgotForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'processRecovery',
		email_forgot: $("#email_forgot").val()
	},
	function(data){
		if(data.result == 'success') {
			document.querySelector('.loginPopup').classList.remove('open');
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

//-------------rework the show error function + helpers for more flexibility------------------//
function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  		if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){
	   			_gaq.push(['_trackPageview', extras.step_content]);

	        	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				document.location = extras.exact_path;
			}
			else
			{
				document.location= extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
				if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}
}

function showErrors(data,formId,extras)
{
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];
	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result")
		{
			if(extras.add_parent_error != undefined)
			{
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			if(value!=1) { $("#"+formId+" .errorMsg").html($("#"+formId+" .errorMsg").html()+"<li>"+value+"</li>"); }
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red below</li></ul>");
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}
function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
}
